export class NgSelectSimple {
    validatorMessage?: boolean;
    tooltipMessage?: boolean;
    openWhenFocus?: boolean;
    searchBy?: string;
    markFirstItem?: boolean;
    submitted?: boolean;
    searchable?: boolean;
    validatorAlert?: boolean;
    upperCase?: boolean;
    appendTo?: string;
    loadingText?: string;
    clearAllText?: string;
    markFirst?: boolean;
    clearable?: boolean;
    clearOnBackspace?: boolean;
    virtualScroll?: boolean;
    openOnEnter?: boolean;
}